var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 15.7693,
    r: 3.07692,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 7C24.8433 7 28.7692 10.9261 28.7692 15.7692C28.7692 17.4712 28.2 19.424 27.2201 21.485C26.249 23.5278 24.9345 25.5526 23.5873 27.3643C22.9294 28.2491 22.2703 29.0742 21.65 29.8158L22.9545 31.3719C26.2405 27.4895 30.7692 21.1609 30.7692 15.7692C30.7692 9.82159 25.948 5 19.9999 5C14.0519 5 9.23071 9.82159 9.23071 15.7692C9.23071 22.327 15.4682 30.2709 18.2749 33.5135C19.0897 34.4549 19.6153 35 19.6153 35C19.6153 35 20.1601 34.474 21.0088 33.5632C21.1014 33.4638 21.1977 33.3599 21.2972 33.2515L20.0009 31.7054C19.9612 31.749 19.9219 31.792 19.8832 31.8344C19.8098 31.9145 19.7382 31.9921 19.6686 32.0673C19.6183 32.0088 19.567 31.9489 19.5146 31.8875C18.5719 30.7817 17.3176 29.2252 16.0674 27.4193C13.489 23.6949 11.2307 19.3336 11.2307 15.7692C11.2307 10.9261 15.1565 7 19.9999 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.593c13b79b7ad5e55a1511f60ac0fceb.svg";
export { ForwardRef as ReactComponent };